import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: January 2024</p>

          <section>
            <h2>1. Information We Collect</h2>
            <p>AuVSys collects information to provide better services to our clients and website visitors. We collect information in the following ways:</p>
            <ul>
              <li>Information you give us directly through forms, inquiries, and service requests</li>
              <li>Information we get from your use of our services and website</li>
              <li>Information from third-party sources when you authorize such sharing</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices, updates, and support messages</li>
              <li>Respond to comments, questions, and customer service requests</li>
              <li>Communicate about products, services, and events</li>
            </ul>
          </section>

          <section>
            <h2>3. Information Sharing</h2>
            <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy.</p>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
          </section>

          <section>
            <h2>5. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at:</p>
            <p>Email: privacy@auvsys.com<br />
            Phone: +60 XX XXX XXXX</p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;